import { useSelector } from "react-redux";
import { useGetBuckeyeLinkDataQuery } from "../../services/graphql/api";
import { selectStoredQuickLinkPreferences } from "../../services/graphql/slices/preferences";
import { selectQuickLinks } from "../../services/graphql/slices/buckeye-link";

const parseQuickLinks = (data) => (data?.quickLinks || []).filter(o => {
  return o.title && o.link
});

function useQuickLinks() {
  const queryResponse = useGetBuckeyeLinkDataQuery();
  const { custom, quickLinks } = useSelector(state => {
    const reduxQuickLinks = selectQuickLinks(state)
    const ql = selectStoredQuickLinkPreferences(state)
    let res = {
      custom: false,
      quickLinks: parseQuickLinks({ quickLinks: reduxQuickLinks ?? [] })
    }
    if(ql?.length >= 3) {
      res.custom = true
      res.quickLinks = ql
    }
    
    res.quickLinks = (res.quickLinks ?? []).slice(0, 25)
    
    return res
  })

  return {
    ...queryResponse,
    custom,
    links: quickLinks ?? []
  }
}

export default useQuickLinks;
